
import 'antd/dist/antd.css'
import { message } from 'antd';
import { Modal, Popover, Button } from 'antd';
import { SVPAGE_CR_PRESELECT, COSMOS_DEF_ROUND_ADV_DAYS_O, COSMOS_DEF_ROUND_ADV_DAYS_D } from '../../constants'
import { SJCR_ORG_OVERLAY } from '../../constants'
import React, { Component } from "react"
import SVCKPort from '../../views/SVCKPort';

import { Input, Card, DatePicker, Select } from 'antd'
import moment from 'moment'

import { Menu, Icon } from 'antd';




import '../../css/SearchBar.css'
const _ = require('lodash')
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Search } = Input;




const infoError = () => {
    message.info('Please enter all valid data');
};


class CliSearchBar extends Component {
    componentWillMount() {
        console.log('sv--componentWillMount called')
        console.log(this.initStateRegion())
    }
    showAllFilterContent() {
        let tcontent = '<div></div>'

        let fapply =  this.state.fapply
        if(fapply == false){
                return (<noop></noop>)
        }
        //let mywidth = '900px'
        let mywidth = '100%'
        const { visible, loading } = this.state;
        tcontent = (
            <div className="c-box-flybar-travel">
                <span className="c-span">
                    <div>

                        <br />
                        <Card title="All Filters" bordered={false} style={{ width: 265 }}>
                            <div>
                                <Button type="primary"  className="ant-btn-sea" icon="transaction" onClick={this.showModal}>
                                    Filters
                                </Button>
                                <Modal
                                    width={mywidth}
                                    visible={visible}
                                    title="All Filters"
                                    onOk={this.handleOk}
                                    onCancel={this.handleCancel}
                                    footer={[
                                        <Button key="back" onClick={this.handleCancel}>
                                            Reset All
                                        </Button>,
                                        <Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>
                                            Apply
                                        </Button>,
                                    ]}
                                >
                                    <p>Some contents...</p>
                                    {this.getFiltersOverlay()}
                                </Modal>
                            </div>




                        </Card>
                    </div>

                </span>
            </div>
        )

        return tcontent
    }
    showSailFromContent_Oldr(svcli_meta_data) {
        const { port } = svcli_meta_data

        let tcontent = '<div></div>'
        if (SJCR_ORG_OVERLAY) {
            tcontent = (
                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card title="Sail From New" bordered={false} style={{ width: 265 }}>
                                <Popover placement="bottomRight" title="Sal=il From" content={this.getOrgOverlay()} trigger="click">
                                    <Button>

                                        {this.norgSummary()}</Button>
                                </Popover>
                            </Card>
                        </div>

                    </span>
                </div>
            )
        } else {
            tcontent = (
                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>

                            <br />
                            <Card title="Sail From" bordered={false} style={{ width: 265 }}>
                                <Select onChange={this.handleSailFromChange} defaultValue="MIA" style={{ width: 170, marginTop: "6px" }} >


                                    {


                                        port.map((o, idx) => (
                                            <Option value={o.code} key={o.code}>{o.label}</Option>
                                        )




                                        )}
                                </Select>




                            </Card>
                        </div>

                    </span>
                </div>
            )

        }
        return tcontent

    }
    /*svaug5*/
    showSailFromContent(svcli_meta_data) {
        const { port } = svcli_meta_data

        let tcontent = '<div></div>'
        if (SJCR_ORG_OVERLAY) {
            tcontent = (
                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card title="Sail From New" bordered={false} style={{ width: 265 }}>
                                <Popover placement="bottomRight" title="Sal=il From" content={this.getOrgOverlay()} trigger="click">
                                    <Button>

                                        {this.norgSummary()}</Button>
                                </Popover>
                            </Card>
                        </div>

                    </span>
                </div>
            )
        } else {
            tcontent = (
                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>

                            <br />
                            <Card title="Sail From" bordered={false} style={{ width: 265 }}>
                                <SVCKPort onSearchOrgtxtFancy={this.onSearchOrgtxtFancy}/>
                            </Card>
                        </div>

                    </span>
                </div>
            )

        }
        return tcontent

    }
    nshipSummary() {
        const { svship } = this.state.filters
        const regIds = Object.keys(svship)
        const rarIds_s = regIds.filter(id => svship[id]);
        const n = rarIds_s ? rarIds_s.length : 0
        const ns = n < 1 ? '' : `( ${n} )`
        const c = "Ships"
        let fapply = true
        if( (n == 1) && rarIds_s.includes('SVALL')){
            fapply = false
        }else if(n == 0){
            fapply = false

        }

        let tcontent = `${c} ${ns} `
        console.log(tcontent)
        return tcontent
    }
    nregionSummary() {
        const { svdur, svreg, svship } = this.state.filters
        const regIds = Object.keys(svreg)
        const rarIds_s = regIds.filter(id => svreg[id]);
        const n = rarIds_s ? rarIds_s.length : 0
        const ns = n < 1 ? '' : `( ${n} )`
        const c = "Sail To"

        let tcontent = `${c} ${ns} `
        console.log(tcontent)
        return tcontent
    }
    norgSummary() {
        const { svorg } = this.state.filters
        const regIds = Object.keys(svorg)
        const rarIds_s = regIds.filter(id => svorg[id]);
        const n = rarIds_s ? rarIds_s.length : 0
        const ns = n < 1 ? '' : `( ${n} )`
        const c = "Sail From"

        let tcontent = `${c} ${ns} `
        console.log(tcontent)
        return tcontent
    }
    ndurSummary() {
        const { svdur } = this.state.filters
        const regIds = Object.keys(svdur)
        const rarIds_s = regIds.filter(id => svdur[id]);
        const n = rarIds_s ? rarIds_s.length : 0
        const ns = n < 1 ? '' : `( ${n} )`
        const c = "Duration"

        let tcontent = `${c} ${ns} `
       
        return tcontent
    }

    getShipOverlay() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { shipCode } = svcli_meta_data

        const content = (
            <div className="row">
                <div className="c-container-crshipbar">
                    {
                        shipCode.map((o, idx) => (

                            <div className="c-box-crshipbar">
                                <span className="c-span">
                                    <Button type="dashed" style={{ backgroundColor: this.state.filters.svship[o.code] ? "#afd5c8" : "white" }} onClick={this.shipCurry(o.code, this)}>
                                        {o.label}
                                    </Button>
                                </span>

                            </div>
                        ))
                    }
                </div>
            </div>
        );
        return content

    }
    getDurOverlay() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { dur } = svcli_meta_data

        const content = (
            <div className="row">
                <div className="c-container-crsdurbar">
                    {
                        dur.map((o, idx) => (

                            <div className="c-box-crdurbar">
                                <span className="c-span">
                                    <Button type="dashed" style={{ backgroundColor: this.state.filters.svdur[o.code] ? "#afd5c8" : "white" }} onClick={this.durCurry(o.code, this)}>
                                        {o.label}
                                    </Button>
                                </span>

                            </div>
                        ))
                    }
                </div>
            </div>
        );
        return content

    }
    getOrgOverlay() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { port } = svcli_meta_data

        const content = (
            <div className="row">
                <div className="c-container-crorgbar">
                    {
                        port.map((o, idx) => (

                            <div className="c-box-crorgbar">
                                <span className="c-span">
                                    <Button type="dashed" style={{ backgroundColor: this.state.filters.svorg[o.code] ? "#afd5c8" : "white" }} onClick={this.orgCurry(o.code, this)}>
                                        {o.label}
                                    </Button>
                                </span>

                            </div>
                        ))
                    }
                </div>
            </div>
        );
        return content

    }
    getShipOverlay_old() {
        const content = (
            <div className="row">
                <div className="c-container-crshipbar">

                    <div className="c-box-crshipbar">
                        <span className="c-span">
                            <Button type="dashed" style={{ backgroundColor: this.state.filters.alaska ? "#afd5c8" : "white" }} onClick={this.regionCurry('alaska', this)}>
                                Alaska
                            </Button>
                        </span>

                    </div>
                    <div className="c-box-crshipbar">

                        <span className="c-span">
                            <Button type="dashed" style={{ backgroundColor: this.state.filters.carribean ? "#afd5c8" : "white" }} onClick={this.regionCurry('carribean', this)}>
                                Carribean
                            </Button>
                        </span>
                    </div>
                    <div className="c-box-crshipbar">

                        <span className="c-span">
                            <Button type="dashed" style={{ backgroundColor: this.state.filters.bahmas ? "#afd5c8" : "white" }} onClick={this.regionCurry('bahmas', this)}>
                                Bahamas
                            </Button>
                        </span>
                    </div>
                    <div className="c-box-crshipbar">

                        <span className="c-span">
                            <Button type="dashed" style={{ backgroundColor: this.state.filters.europe ? "#afd5c8" : "white" }} onClick={this.regionCurry('europe', this)}>
                                Relaxway, Halfmoon Cay
                            </Button>
                        </span>
                    </div>
                    <div className="c-box-crshipbar">

                        <span className="c-span">
                            <Button type="dashed" style={{ backgroundColor: this.state.filters.europe ? "#afd5c8" : "white" }} onClick={this.regionCurry('panama', this)}>
                                Panama
                            </Button>
                        </span>
                    </div>


                </div>
            </div>
        );
        return content

    }
    /*ship end*/
    /*svjun6  start*/
    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = () => {
        this.setState({ loading: true });
        setTimeout(() => {
            this.setState({ loading: false, visible: false });
        }, 3000);
    };
    getFiltersModal() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { dest } = svcli_meta_data


        const content = (

            <div className="row">
                <Card title="Cruise Dates" extra={<a href="#">More</a>} style={{ width: 300 }}>
                    <p>Card content</p>

                </Card>
                <Card title="Departure Port" extra={<a href="#">More</a>} style={{ width: 300 }}>
                    <p>Card content</p>

                </Card>
                <Card title="Destinations" extra={<a href="#">More</a>} style={{ width: 300 }}>
                    <p>Card content</p>

                </Card>
                <Card title="Number Of Nights" extra={<a href="#">More</a>} style={{ width: 300 }}>
                    <p>Card content</p>

                </Card>
                <Card title="Number Of Guests" extra={<a href="#">More</a>} style={{ width: 300 }}>
                    <p>Card content</p>
                    <div className="c-container-crregionbar">
                        {
                            dest.map((o, idx) => (

                                <div className="c-box-crregionbar">
                                    <span className="c-span">
                                        <Button type="dashed" style={{ backgroundColor: this.state.filters.svreg[o.REGION_ID] ? "#afd5c8" : "white" }} onClick={this.regionCurry(o.REGION_ID, this)}>
                                            {o.LABEL}
                                        </Button>
                                    </span>

                                </div>
                            ))
                        }
                    </div>

                </Card>


            </div>
        );
        return content

    }

    handleCancel = () => {
        //make 
        /*
        svreg: { 53: false },

                //code
                svship: { "AQ": false },
                //code
                svdur: { "D1": false },
                svorg: { "MIA": false },

                 let svship = {}, svdur= {
        D1:false,
        D2:false,
        D3:false,
        SVALL: true
    }
        */
      
    let f = this.state.filters
    let svreg = f['svreg']
    let svship = f['svship'] 
    let svdur = f['svdur'] 
    let kallreg = 3333
    let sallreg = 'SVALL'
    let salldur = 'SVALL'
    let nreg = {}
    let sship = {}
    let sdur = {}
    let dids = Object.keys(svdur)
    let sid = '', nid = -1
    for( let k=0; k < dids.length; k++){
         sid = dids[k]
        if(sid == salldur){
            sdur[sid] = true
        }else{
            sdur[sid] = false
        }
       

    }

    let sids = Object.keys(svship)
    for( let k=0; k < sids.length; k++){
         sid = sids[k]
        if(sid == sallreg){
            sship[sid] = true
        }else{
            sship[sid] = false
        }
       

    }

    let rids = Object.keys(svreg)
    for( let k=0; k < rids.length; k++){
         nid = rids[k]
        if(nid == kallreg){
            nreg[nid] = true
        }else{
            nreg[nid] = false
        }
       

    }
    f['svreg'] = nreg
    f['svship'] = sship
    f['svdur'] = sdur



    this.setState({ filters: f,visible: false  })
      

       // this.setState({ visible: false });
    };


    getFiltersOverlay() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
    
        
        const {  svdur, svreg, svship , esquerySailfrom} = this.state.filters
        const {shipCode,dest, svbrand,dur,port} = my_data_meta
        const regIds = Object.keys(svreg)
        const shipIds = Object.keys(svship)
        const durIds = Object.keys(svdur)
        //const durIds = Object.keys(portIds)
        let portIds_s = []
        portIds_s.push(esquerySailfrom)
        
        const rarIds_s = regIds.filter(id => svreg[id]);
        const shipIds_s = shipIds.filter(id => svship[id]);
        const durIds_s = durIds.filter(id => svdur[id]);
        //const portIds_s = portIds.filter(id => svdur[id]);
        let arports =port.filter( o=>{let sel = false;
            if( portIds_s.includes(o.code)){
                 sel = true
                
            }else{
               sel = false
            }
            return sel
   })

        let ardurs =dur.filter( o=>{let sel = false;
            if( durIds_s.includes(o.code)){
                 sel = true
                
            }else{
               sel = false
            }
            return sel
   })

        let arships =shipCode.filter( o=>{let sel = false;
             if( shipIds_s.includes(o.code)){
                  sel = true
                 
             }else{
                sel = false
             }
             return sel
    })
    let arregs =dest.filter( o=>{let sel = false;
        if( rarIds_s.includes("" + o.REGION_ID)){
             sel = true
            
        }else{
           sel = false
        }
        return sel
})
        const content = (

            <div className="row">
                <Card title="Duration"  bordered={false}>
                    <p>Duration content</p>
                    <div className="c-container-crregionbar">
                        {
                            ardurs.map((o, idx) => (

                                <div className="c-box-crregionbar">
                                    <span className="c-span">
                                        <Button type="dashed" style={{ backgroundColor:  "#afd5c8" }} onClick={this.afdurCurry(o.code, this)}>
                                            {o.label}
                                        </Button>
                                    </span>

                                </div>
                            ))
                        }
                    </div>

                </Card>
                <Card title="Departure Port" bordered={false}>
                    <p>Port content</p>
                    <div className="c-container-crregionbar">
                        {
                            arports.map((o, idx) => (

                                <div className="c-box-crregionbar">
                                    <span className="c-span">
                                        <Button type="dashed" style={{ backgroundColor:  "#afd5c8" }} onClick={this.afportCurry(o.code, this)}>
                                            {o.label}
                                        </Button>
                                    </span>

                                </div>
                            ))
                        }
                    </div>

                </Card>
                <Card title="Destinations" bordered={false}>
                    <p>Region content</p>
                    <div className="c-container-crregionbar">
                        {
                            arregs.map((o, idx) => (

                                <div className="c-box-crregionbar">
                                    <span className="c-span">
                                        <Button type="dashed" style={{ backgroundColor:  "#afd5c8" }} onClick={this.afregCurry(o.id, this)}>
                                            {o.LABEL}
                                        </Button>
                                    </span>

                                </div>
                            ))
                        }
                    </div>

                </Card>
                <Card title="Ships" bordered={false}>
                    <p>Ships content</p>
                    <div className="c-container-crregionbar">
                        {
                            arships.map((o, idx) => (

                                <div className="c-box-crregionbar">
                                    <span className="c-span">
                                        <Button type="dashed" style={{ backgroundColor:  "#afd5c8" }} onClick={this.afshipCurry(o.code, this)}>
                                            {o.label}
                                        </Button>
                                    </span>

                                </div>
                            ))
                        }
                    </div>

                </Card>
               


            </div>
        );
        return content

    }


    /*svjun6 end */

    getRegionOverlay() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { dest } = svcli_meta_data


        const content = (
            <div className="row">
                <div className="c-container-crregionbar">
                    {
                        dest.map((o, idx) => (

                            <div className="c-box-crregionbar">
                                <span className="c-span">
                                    <Button type="dashed" style={{ backgroundColor: this.state.filters.svreg[o.REGION_ID] ? "#afd5c8" : "white" }} onClick={this.regionCurry(o.REGION_ID, this)}>
                                        {o.LABEL}
                                    </Button>
                                </span>

                            </div>
                        ))
                    }
                </div>
            </div>
        );
        return content

    }


    initStateRegion() {
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta
        const { dest, shipCode, dur } = svcli_meta_data

        let svreg = { 53: true }
        let svship = { "AQ": false }
        let svdur = { "D1": false }

        dest.map(o => {
           
            if (o.REGION_ID == SVPAGE_CR_PRESELECT.SVREG_ID) {
                svreg[o.REGION_ID] = true
            } else {
                svreg[o.REGION_ID] = false
            }



        })
        shipCode.map(o => {
           
            if (o.code == SVPAGE_CR_PRESELECT.SVSHIP_CODE) {
                svship[o.code] = true
            } else {
                svship[o.code] = false
            }


        })
        dur.map(o => {
           
            if (o.code == SVPAGE_CR_PRESELECT.SVDUR_CODE) {
                svdur[o.code] = true
            } else {
                svdur[o.code] = false
            }


        })


        let f = this.state.filters
        f['svreg'] = svreg
        f['svship'] = svship
        f['svdur'] = svdur

        this.setState({ filters: f })
    }

    constructor(props) {
        super(props)
        let me = this
        this.state = {
            fapply: false,
            loading: false,
            visible: false,

            filters: {
                /*svmay12 start */
                //REGION_ID
                svreg: { 53: false },

                //code
                svship: { "AQ": false },
                //code
                svdur: { "D1": false },
                svorg: { "MIA": false },
                /*svmay12 end */
                alaska: false,
                carribean: false,

                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
                // "endDate": "2024-07-22T25:42:55.795+00:00" ,
                startDate: new Date(),
                endDate: new Date(),
                esqueryAdults: "t1",
                esqueryChilds: "m1",
                esqueryInfants: "i0",

                esqueryPortcall: "MIA",
                esqueryShip: ["AQ"],
                esquerySpecials: "J",
                esqueryDur: ["D1"],
                esqueryBrand: ["CARN"],
                esquerySailfrom: "MIA",
                esquerySailto: "A",
                esqueryRegionIds: [57],



                esqueryText: '',

                dataSourceSV: ['Burns Bay Road', 'Downing Street', 'Wall Street'],


                key: 'selection',
                hotelsSelected: { "value": "kenServer", "label": "kenServer" },

            }
        }
        //cliAndImagesSVUsingQuery
        this.cliAndImagesSVUsingQuery = this.cliAndImagesSVUsingQuery.bind(this)
        this.momDefaultDateRCli = this.momDefaultDateRCli.bind(me)
        this.getShipTravelTypeView = this.getShipTravelTypeView.bind(this)
        //this.getRegionOverlay = this.getRegionOverlay.bind(this)
        this.nregionSummary = this.nregionSummary.bind(this)
        this.nshipSummary = this.nshipSummary.bind(this)
        this.ndurSummary = this.ndurSummary.bind(this)
        this.norgSummary = this.norgSummary.bind(this)



        this.regionCurry = this.regionCurry.bind(this)
        this.afshipCurry = this.afshipCurry.bind(this) 
        this.afdurCurry = this.afdurCurry.bind(this) 
        this.afregCurry = this.afregCurry.bind(this)
        this.afportCurry = this.afportCurry.bind(this)

        this.durCurry = this.durCurry.bind(this)
        this.shipCurry = this.shipCurry.bind(this)
        this.orgCurry = this.orgCurry.bind(this)



        this.getShipOverlay = this.getShipOverlay.bind(this)
        this.getOrgOverlay = this.getOrgOverlay.bind(this)
        this.getDurOverlay = this.getDurOverlay.bind(this)
        this.getRegionOverlay = this.getRegionOverlay.bind(this)
        /*svjun6 start */
        this.getFiltersOverlay = this.getFiltersOverlay.bind(this)
        this.getFiltersModal = this.getFiltersModal.bind(this)
        this.showAllFilterContent = this.showAllFilterContent.bind(this)
        /*svjun6 end */
        this.showSailFromContent = this.showSailFromContent.bind(this)



        this.nshipSummary = this.nshipSummary.bind(this)
        this.shipCurry = this.shipCurry.bind(this)
        this.initStateRegion = this.initStateRegion.bind(this)

        this.handleChange = this.handleChange.bind(this)
        this.handleTravellerChange = this.handleTravellerChange.bind(this)
        this.handleDstCountryChange = this.handleDstCountryChange.bind(this)

        this.handleChildChange = this.handleChildChange.bind(this)
        this.handleSailToChange = this.handleSailToChange.bind(this)
        //svmar5 start
        this.handleSailRegionToChange = this.handleSailRegionToChange.bind(this)
        //svmar5 end
        this.handleSailFromChange = this.handleSailFromChange.bind(this)
        this.handlePortcallChange = this.handlePortcallChange.bind(this)
        //svaug5
        this.onSearchOrgtxtFancy = this.onSearchOrgtxtFancy.bind(this)
       
        //svmar4
        this.handleBrandcallChange = this.handleBrandcallChange.bind(this)
        //handlePortcallChange
        //handleDurChange
        this.handleDurChange = this.handleDurChange.bind(this)
        this.handleShipChange = this.handleShipChange.bind(this)
        this.onSailChange_cruise = this.onSailChange_cruise.bind(this)
        //onSailChange_Oneway_cosmos
    }

    onSailChange_cruise(dateMoment, sdate, tpdateMoment, tosdate) {
        
        let fmd = dateMoment
        let fmo = fmd[0]
        let tmo = fmd[1]
        let moEndDate = moment(tmo)
        let moStartDate = moment(fmo)
        
        let mo_es = moEndDate.format('YYYY-MM-DD')
        let mo_ss = moStartDate.format('YYYY-MM-DD')
        let end_date_s = moEndDate.toISOString()
        let start_date_s = moStartDate.toISOString()
       
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt : fmo
        f['endDate'] = !tmo ? today_dt : tmo
        this.setState({ filters: f })
        // this.saveFindState()

    }
    momDefaultDateRCli() {
        let oMom = null, dMom = null
        let today = moment(), todatD = moment()
        let dar = [today, today]
        // const {COSMOS_DEF_SEARCH_ADV_DAYS} 
        let advBy = parseInt(COSMOS_DEF_ROUND_ADV_DAYS_O) ? parseInt(COSMOS_DEF_ROUND_ADV_DAYS_O) : 14
        let advRBy = parseInt(COSMOS_DEF_ROUND_ADV_DAYS_D) ? parseInt(COSMOS_DEF_ROUND_ADV_DAYS_D) : 20


        if (today) {
            oMom = today.add(advBy, 'days')
            dMom = todatD.add(advRBy, 'days')
            dar = []
            dar.push(oMom)
            dar.push(dMom)
        }



        return dar

    }
    handleShipChange(qarIds) {
        

        let f = this.state.filters
        if (qarIds && (qarIds.length > 0)) {
            f['esqueryShip'] = qarIds
            this.setState({ filters: f })

        }

    }

    handlePortcallChange(qText) {
        
        let f = this.state.filters
        f['esqueryPortcall'] = !qText ? 't1' : qText
        this.setState({ filters: f })
    }

    handleBrandcallChange(qText) {
        
        let f = this.state.filters
        f['esqueryBrand'] = !qText ? 't1' : qText
        this.setState({ filters: f })
    }

    handleDurChange(qarIds) {
       

        let f = this.state.filters
        if (qarIds && (qarIds.length > 0)) {
            f['esqueryDur'] = qarIds
            this.setState({ filters: f })
        }

    }
    handleSailRegionToChange(qarIds) {
       
        let f = this.state.filters
        if (qarIds && (qarIds.length > 0)) {
            f['esqueryRegionIds'] = qarIds
            this.setState({ filters: f })

        }


    }
    handleSailToChange(qText) {
       
        let f = this.state.filters
        f['esquerySailto'] = !qText ? 't1' : qText
        this.setState({ filters: f })
    }
    handleSailFromChange(qText) {
       
        let f = this.state.filters
        f['esquerySailfrom'] = !qText ? 't1' : qText
        this.setState({ filters: f })
    }
    /*svaug5*/
    onSearchOrgtxtFancy = mob => {
        
        console.log('KN*********** July17 GOT SVKAirport  selectom options.name 0')
        
        console.log(mob)
        let f = this.state.filters
       
        f['esquerySailfrom'] = !mob  ? {} :mob
        let qText = mob.IATA
       
        f['esquerySailfrom'] = !qText ? [] :  qText
        console.log('SV*********** APR7 GOT TA selectom options.name', qText)
        
        this.setState({filters:f} )
       
        
      };
    handleDstCountryChange(qText) {
        console.log(`selected handleDstCountryChange ${qText}`);
    }
    handleChange(qText) {
        console.log(`selected handleChange ${qText}`);
    }
    handleTravellerChange(qText) {
       
        let f = this.state.filters
        f['esqueryAdults'] = !qText ? 't1' : qText
        this.setState({ filters: f })


    }
    handleChildChange(qText) {
        
        let f = this.state.filters
        f['esqueryChilds'] = !qText ? 'm1' : qText
        this.setState({ filters: f })
        // this.saveFindState()



    }
    /*svmar12 */
    shipCurry_old = (param1, ctx) => (event) => {
        let me = ctx
       
        let f = this.state.filters
        if (param1 == 'alaska') {
            let { alaska } = f
            f['alaska'] = !alaska


            this.setState({ filters: f })
        }
        if (param1 == 'bahmas') {
            let { bahmas } = f
            f['bahmas'] = !bahmas


            this.setState({ filters: f })
        }
        if (param1 == 'carribean') {
            let { carribean } = f
            f['carribean'] = !carribean


            this.setState({ filters: f })
        }
        if (param1 == 'europe') {
            let { europe } = f
            f['europe'] = !europe


            this.setState({ filters: f })
        }
        if (param1 == 'panama') {
            let { panama } = f
            f['panama'] = !panama


            this.setState({ filters: f })
        }


    }
    //afshipCurry
    afshipCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        console.log(param1)
        console.log('end rid **')
        /*
        let f = this.state.filters
        let { svreg } = f
        let rid = param1
        let rid_val = svreg[rid]
        console.log(rid)
        svreg[rid] = !rid_val

        f['svreg'] = svreg

        this.setState({ filters: f })
        */

    }
    afdurCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('dur name ', param1)
        console.log(param1)
        console.log('end rid **')
        /*
        let f = this.state.filters
        let { svreg } = f
        let rid = param1
        let rid_val = svreg[rid]
        console.log(rid)
        svreg[rid] = !rid_val

        f['svreg'] = svreg

        this.setState({ filters: f })
        */

    }
    afportCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        console.log(param1)
        console.log('end rid **')
        /*
        let f = this.state.filters
        let { svreg } = f
        let rid = param1
        let rid_val = svreg[rid]
        console.log(rid)
        svreg[rid] = !rid_val

        f['svreg'] = svreg

        this.setState({ filters: f })
        */

    }
    afregCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        console.log(param1)
        console.log('end rid **')
        /*
        let f = this.state.filters
        let { svreg } = f
        let rid = param1
        let rid_val = svreg[rid]
        console.log(rid)
        svreg[rid] = !rid_val

        f['svreg'] = svreg

        this.setState({ filters: f })
        */

    }
    regionCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        console.log(param1)
        console.log('end rid **')
        /*
        const {locationData} = this.props
        const {svcli_meta_data} = locationData
        const { dest} = svcli_meta_data
        */
        let f = this.state.filters
        let { svreg } = f
        let rid = param1
        let rid_val = svreg[rid]
        console.log(rid)
        svreg[rid] = !rid_val

        f['svreg'] = svreg

        this.setState({ filters: f })

    }
    regionCurry_old = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        let f = this.state.filters
        if (param1 == 'alaska') {
            let { alaska } = f
            f['alaska'] = !alaska


            this.setState({ filters: f })
        }
        if (param1 == 'bahmas') {
            let { bahmas } = f
            f['bahmas'] = !bahmas


            this.setState({ filters: f })
        }
        if (param1 == 'carribean') {
            let { carribean } = f
            f['carribean'] = !carribean


            this.setState({ filters: f })
        }
        if (param1 == 'europe') {
            let { europe } = f
            f['europe'] = !europe


            this.setState({ filters: f })
        }
        if (param1 == 'panama') {
            let { panama } = f
            f['panama'] = !panama


            this.setState({ filters: f })
        }


    }
    shipCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('ship name ', param1)
        console.log(param1)
        console.log('end rid **')

        let f = this.state.filters
        let { svship } = f
        let rid = param1
        let rid_val = svship[rid]
        console.log(rid)
        svship[rid] = !rid_val

        f['svship'] = svship

        this.setState({ filters: f })

    }
    orgCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('org from name ', param1)
        console.log(param1)
        console.log('end rid **')


        let f = this.state.filters
        let { svorg } = f

        let rid = param1
        let rid_val = svorg[rid]
        console.log(rid)
        svorg[rid] = !rid_val

        f['svorg'] = svorg
        this.setState({ filters: f })

    }
    durCurry = (param1, ctx) => (event) => {
        let me = ctx
        console.log('region name ', param1)
        console.log(param1)
        console.log('end rid **')


        let f = this.state.filters
        let { svdur, esqueryDur } = f

        let rid = param1
        let rid_val = svdur[rid]
        console.log(rid)
        svdur[rid] = !rid_val

        f['svdur'] = svdur
        this.setState({ filters: f })

    }
    handleAVisibleToggle = visible => {
        let f = this.state.filters
        let { alaska } = f
        f['alaska'] = !alaska


        this.setState({ filters: f })
    };

    handleBVisibleToggle = visible => {
        let f = this.state.filters
        let { bahmas } = f
        f['bahmas'] = !bahmas


        this.setState({ filters: f })
    };



    getShipTravelTypeView(svcli_meta_data) {
        /*svjun6*/
        const { visible, loading } = this.state;
        /*svjun6 end*/
        const { port, shipCode, dest, dur, durDays, specials, datFrom } = svcli_meta_data
        let qt = 'onewaytrip'

        return (
            <div className="c-container-sbar">
               
                 {this.showAllFilterContent()}
                {this.showSailFromContent(svcli_meta_data)}

                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card title="Sail To Regions" bordered={false} style={{ width: 265 }}>



                                <Popover placement="bottomRight" title="Select Regions" content={this.getRegionOverlay()} trigger="click">
                                    <Button>

                                        {this.nregionSummary()}</Button>
                                    {/*  <span class="AllFiltersButton">3</span> */}

                                </Popover>



                            </Card>
                        </div>

                    </span>
                </div>
               


                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card title="Ships" bordered={false} style={{ width: 265 }}>



                                <Popover placement="bottomRight" title="Select Ships" content={this.getShipOverlay()} trigger="click">
                                    <Button>{this.nshipSummary()}</Button>
                                </Popover>



                            </Card>
                        </div>

                    </span>
                </div>


                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card title="Duration" bordered={false} style={{ width: 265 }}>



                                <Popover placement="bottomRight" title="Durations" content={this.getDurOverlay()} trigger="click">
                                    <Button>{this.ndurSummary()}</Button>
                                </Popover>



                            </Card>
                        </div>

                    </span>
                </div>



                <div className="c-box-flybar-travel">
                    <span className="c-span">

                        {this.getTripHtmlPicker(qt)}

                    </span>
                </div>


                <div className="c-box-flybar-travel">
                    <span className="c-span">
                        <div>
                            <br />
                            <Card bordered={false} style={{ width: 130 }}>

                                <button type="submit" className="btn btn-success" onClick={() => this.cliAndImagesSVUsingQuery(this.state.filters)}>
                                    Search
                                </button>
                            </Card>
                        </div>
                    </span>
                </div>
            </div>
        )

    }

    //start render
    render() {
       
    
        let svbrandTest = null
        let { my_data_meta } = this.props
        let { port, portCall, svbrand } = my_data_meta
        let svcli_meta_data = my_data_meta
        
        if (my_data_meta && (my_data_meta.port) && (my_data_meta.port.length > 10)) {


            svbrand = my_data_meta.svbrand
           

        }
        if (!(my_data_meta && (my_data_meta.port) && (my_data_meta.port.length > 10))) {


            svbrand = [

                {
                    "code": "CARN",
                    "enabled": true,
                    "label": "Carnival Cruises"
                }
            ]
            port = [
                {
                    "code": "ADL",
                    "enabled": false,
                    "label": "Adelaide, Australia"
                }]
            portCall = [
                {
                    "code": "ADL",
                    "enabled": false,
                    "label": "Adelaide, Australia"
                }]

        }

      
        return (
            <div>
                <div className="searchBar">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="c-container-profilebar">
                                <div className="c-box-profilebar">
                                    <span className="c-span">
                                        <Select defaultValue="roundtrip" style={{ width: 120 }} onChange={this.handleChange}>
                                            <Option value="roundtrip">Round Trip</Option>
                                            <Option value="onewaytrip">One Way</Option>
                                            <Option value="multicity" >
                                                Multi City
                                            </Option>
                                            {/* 
                                    <Option value="Yiminghe" disabled>yiminghe</Option>
                                    */}
                                        </Select>
                                    </span>
                                </div>
                                <div className="c-box-profilebar">
                                    <span className="c-span">
                                        <Select defaultValue="t1" style={{ width: 120 }} onChange={this.handleTravellerChange}>
                                            <Option value="t1">1 Adult</Option>
                                            <Option value="t2">2 Adult</Option>
                                            <Option value="t3">3 Adult</Option>
                                            <Option value="t4">4 Adult</Option>
                                            <Option value="t5">5 Adult</Option>
                                            <Option value="t6">6 Adult</Option>

                                        </Select>
                                    </span>
                                </div>
                                <div className="c-box-profilebar">
                                    <span className="c-span">
                                        <Select defaultValue="m0" style={{ width: 120 }} onChange={this.handleChildChange}>
                                            <Option value="m0">No Child</Option>
                                            <Option value="m1">1 Child</Option>
                                            <Option value="m2">2 Child</Option>

                                        </Select>
                                    </span>
                                </div>
                                <div className="c-box-profilebar">
                                    <span className="c-span">

                                        <Select onChange={this.handlePortcallChange} defaultValue="MIA" style={{ minWidth: 170 }} >
                                            <Option value="sv">All Ports</Option>

                                            {


                                                portCall.map((o, idx) => (
                                                    <Option value={o.code} key={o.code}>{o.label}</Option>
                                                )




                                                )}
                                        </Select>
                                    </span>
                                </div>
                                <div className="c-box-profilebar">
                                    <span className="c-span">

                                        <Select mode="multiple" onChange={this.handleBrandcallChange} defaultValue="SVALL" style={{ minWidth: "170px", position: "relative", left: "51px" }} >


                                            {


                                                svbrand.map((o, idx) => (
                                                    <Option value={o.code} key={o.code}>{o.label}</Option>
                                                )




                                                )}
                                        </Select>
                                    </span>
                                </div>

                            </div>
                        </div>
                        {this.getShipTravelTypeView(svcli_meta_data)}

                    </div>
                </div>
            </div>
        )
    }
    //end render

    getTripHtmlPicker(qt) {
        // qt = 'onewaytrip'
        return (

            <div>
                <br />
                <Card title="Dates" bordered={false} style={{ width: 300 }}>
                    <RangePicker disabledDate={this.disabledDateR} defaultPickerValue={this.momDefaultDateRCli()} defaultValue={this.momDefaultDateRCli()} onChange={this.onSailChange_cruise} />
                  
                </Card>
            </div>

        )

    }

    cliAndImagesSVUsingQuery(filter) {
        let isFormValid = true

        const { startDate, endDate, esqueryAdults, esqueryChilds, esqueryInfants, esqueryTripType,
            esqueryPortcall, esqueryBrand, esquerySpecials, esquerySailto } = filter
        // const {esqueryRegionIds} = filter

        const { svdur, svreg, svship, svorg } = filter

        const durIds = Object.keys(svdur)
        const qarIds = durIds.filter(id => svdur[id]);
       
        const esqueryDur = qarIds
        let esquerySailfrom = null

        if (SJCR_ORG_OVERLAY === false) {
            esquerySailfrom = filter.esquerySailfrom

        } else {
            const orgIds = Object.keys(svorg)
            const oarIds = orgIds.filter(id => svorg[id]);
            
            esquerySailfrom = oarIds
        }
       

        const shipIds = Object.keys(svship)
        const sarIds = shipIds.filter(id => svship[id]);
       
        const esqueryShip = sarIds


        const regIds = Object.keys(svreg)
        const rarIds_s = regIds.filter(id => svreg[id]);
        let rarIds = []
        rarIds_s.forEach((v, idx) => { _.isString(v) === true ? rarIds.push(parseInt(v)) : rarIds.push(v) })

       
        const esqueryRegionIds = rarIds



       
        if (esqueryBrand && (_.isArray(esqueryBrand)) && (esqueryBrand.length > 0)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }

        if (esqueryRegionIds && (_.isArray(esqueryRegionIds)) && (esqueryRegionIds.length > 0)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }
        if (esqueryDur && (_.isArray(esqueryDur)) && (esqueryDur.length > 0)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }
        if (esqueryShip && (_.isArray(esqueryShip)) && (esqueryShip.length > 0)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }

        if (esqueryPortcall && (esqueryPortcall.length > 1)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }

        if (esquerySailfrom && (esquerySailfrom.length > 1)) {
            // isFormValid = true
        } else {
            isFormValid = false
        }
        if (startDate && (startDate._d)) {

            // isFormValid = true
            console.log('isFormValid**MOMENSEP7***')
        } else {

            isFormValid = false
            // console.log('isFormValid**SEP7 DATE***', isFormValid)
        }

        if (endDate && (endDate._d)) {

            // isFormValid = true
            console.log('isFormValid**MOMENSEP7***')
        } else {

            isFormValid = false
            // console.log('isFormValid**SEP7 DATE***', isFormValid)
        }

        // console.log('isFormValid**', isFormValid)
        if (isFormValid === false) {
            infoError()
            return
        }

        //call action
        let start_date_s = moment(startDate).toISOString()
        // console.log("**formatISO***", start_date_s)


        let moEndDate = moment(endDate)
        let moStartDate = moment(startDate)
        let mo_es = moEndDate.format('YYYY-MM-DD')
        let mo_ss = moStartDate.format('YYYY-MM-DD')
        let end_date_s = moment(endDate).toISOString()
        // console.log("**formatISO***", end_date_s)

        let sojPostRq = {
            "svfields": [
                "images",
                "sojourn_name",
                "address",

                "code",
                "sojournGeocode",
                "categoryCode",
                "categoryGroupCode",
                "accommodationTypeCode",

                "sojourn_city",
                "countryCode",
                "stateCode",
                "postalCode",
                "countryCode",
                "ranking",
                "web",
                "terminals",
                "destinationCode"
            ],
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss : "2025-10-24"),
                "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es : "2025-10-27"),
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "Asia/Kolkata",
                "OP": "range"
            },
            "facets": {
                "accommodationTypeCode": "H"
            },

            "esqueryChilds": "m0",
            "esqueryInfants": "i0",
            "esqueryAdults": "t1",
            "esquerySpecials": "J",

            "esqueryTripType": "roundtrip",
            "svpageSize": 5,
            "codeKeys": [

            ],
            /* during cruise the intermediataey strope where passenger wants to emabark and disemabrk immeigration check to see the city */
            "esqueryTripType": "roundtrip",

            "esqueryPortcall": esqueryPortcall ? esqueryPortcall : "PALL",
            "esqueryShip": "AQ",
            "esquerySpecials": "J",
            "esqueryDur": "D1",

            "esqueryBrand": "SVALL",


            "org": esquerySailfrom ? esquerySailfrom : "MIA",
            "dst": esquerySailto ? esquerySailto : "A"

        }
        sojPostRq['esqueryChilds'] = (esqueryChilds ? esqueryChilds : "m0")
        sojPostRq['esqueryInfants'] = (esqueryInfants ? esqueryInfants : "i0")
        sojPostRq['esqueryAdults'] = (esqueryAdults ? esqueryAdults : "t1")


        sojPostRq['esqueryTripType'] = (esqueryTripType ? esqueryTripType : "roundtrip")

        sojPostRq['esqueryPortcall'] = (esquerySailfrom ? esquerySailfrom : "MIA")
        sojPostRq['esqueryShip'] = (esqueryShip ? esqueryShip : ["AQ"])
        sojPostRq['esquerySpecials'] = (esquerySpecials ? esquerySpecials : "J")
        sojPostRq['esqueryDur'] = (esqueryDur ? esqueryDur : ["D1"])
        sojPostRq['esqueryBrand'] = (esqueryBrand ? esqueryBrand : ["CARN"])

        if (!(esqueryRegionIds && (esqueryRegionIds.length > 0))) {

            console.log('error Validation selecte 1 destimation Region')
            return

        }
        /*
        const { locationData } = this.props
        const { svcli_meta_data } = locationData
        */
        let { my_data_meta } = this.props
        let svcli_meta_data = my_data_meta

        let REGION_DB = svcli_meta_data.dest
        let rob = null
        let vports = []
       
        for (let i = 0; i < esqueryRegionIds.length; i++) {
            let rid = esqueryRegionIds[i]

            rob = _.find(REGION_DB, function (sp) {
                // console.log(sp)
                if ((sp["REGION_ID"] == rid)) {
                    return true
                } else {
                    return false
                }

            })
           
            if (!rob) {
                continue
            }

            let ar = rob.PORTSDEST

            ar.forEach(e_rec => {


                let nameCountry = e_rec['LABEL']
                let ars = nameCountry.split(',')
                let pname = ars[0].trim()
                vports.push(pname)
                // ob =lowercaseKeys(upperOb)
            })

        }
        const uniqueDest = [...new Set(vports)];
        
        sojPostRq['dst'] = uniqueDest


       

        let my_destination_code = esquerySailto ? esquerySailto : "A"
        let sv_esquery_data = {
            my_esqueryText: my_destination_code,
            STARTDATE: (mo_ss ? mo_ss : "2023-10-24"),
            ENDDATE: (mo_es ? mo_es : "2023-11-27"),
            time_zone: "+01:00"

        }

       
        const n = rarIds_s ? rarIds_s.length : 0
        const ns = n < 1 ? '' : `( ${n} )`
        const c = "Ships"
        let fapply = true
        if( (n == 1) && rarIds_s.includes('SVALL')){
            fapply = false
        }else if(n == 0){
            fapply = false

        }
        this.setState({ "fapply": fapply  })
        


        this.props.cliAndImagesSV(sojPostRq, sv_esquery_data)


    }
    //enclass
}
//CliSearchBarBusCom
export default CliSearchBar